import { isSameDay as _isSameDay, format } from 'date-fns';
import { ForwardedRef, forwardRef } from 'react';
import { Range } from 'react-date-range';
import { AiOutlineCalendar } from 'react-icons/ai';
import { IoChevronDown } from 'react-icons/io5';
import { Text } from 'components';
import * as S from './styles';

interface DateRangeInputProps {
  dateRange: Range;
  isDatePickerOpen: boolean;
  callback: VoidFunction;
}

export const DateRangeInput = forwardRef(
  (
    { dateRange, isDatePickerOpen, callback }: DateRangeInputProps,
    ref: ForwardedRef<HTMLDivElement> | null
  ) => {
    const startDate = dateRange.startDate ?? new Date();
    const endDate = dateRange.endDate ?? new Date();

    const isSameDay = _isSameDay(startDate, endDate);

    const formatedDateRange = `${format(startDate, 'dd/MM/yyyy')} ${
      !isSameDay ? `a ${format(endDate, 'dd/MM/yyyy')}` : ''
    }`;

    return (
      <S.DateInputWrapper ref={ref} onClick={callback}>
        <S.TextWrapper>
          <AiOutlineCalendar />
          <Text>
            Filtrar por <strong>{formatedDateRange}</strong>
          </Text>
        </S.TextWrapper>
        <S.ArrowDownContainer $isDatePickerOpen={isDatePickerOpen}>
          <IoChevronDown size={20} />
        </S.ArrowDownContainer>
      </S.DateInputWrapper>
    );
  }
);
